import style from "./FullWidthText.module.css";

export const FullWidthText = (props) => {
    return (
        <div className={style.moduleWrapper}>
            <h2>{props.content.textContent}</h2>
        </div>
    );
};
